<!--
 * @Author: 南枫
 * @Date: 2020-12-02 10:15:06
 * @LastEditors: 南枫
 * @LastEditTime: 2021-08-19 09:39:22
-->
<template>
<div>
    <div>页面开始啦</div>
</div>
    

</template>

<script>
export default {
    /** 组件挂载 */
    components: {},
    /** 数据区 */
    data() {
        return {};
    },
    /** 创建前 */
    beforeCreate(){},
    /** 创建后 */
    cerated() {},
    /** 挂载前 */
    beforeMount () {},
    /** 挂载后 */
    mounted() {},
    /** 更新前 */
    beforeUpdate(){},
    /** 更新后 */
    updated(){},
    /** 方法 */
    methods: {},
    /** 销毁前 */
    beforeDestroy () {},
    /** 销毁后 */
    destroyed() {
    },
};
</script>

<style lang="less" scoped>

</style>